import { useTranslation } from "react-i18next";
import { ContentHeader, MainContentArea } from "melco-ui";
import { useBreadcrumb } from "../../../hooks/navigation/useBreadcrumb";
import { MachineLicensesList } from "../../../components/infrastructure/machinelicenses/MachineLicensesList";

export const MachineLicenses: React.FC = () => {
  const { t } = useTranslation();
  const breadcrumb = useBreadcrumb("infrastructure");

  //const addLicenseDrawer = useGenericDrawer();
 // const { openDrawer } = addLicenseDrawer;

  return (
    <MainContentArea
      header={
        <ContentHeader
          title={t("main_menu.machine_licenses")}
          breadcrumb={breadcrumb}
         // extra={<AddLicenseButton onClick={openDrawer} />}
        />
      }
    >
      <MachineLicensesList />
      {/* <AddLicenseDrawer drawer={addLicenseDrawer} /> */}
    </MainContentArea>
  );
};
